/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_Status_Label_SentInputs */

const tr_landing_telegram_mock_status_label_sent = /** @type {(inputs: Landing_Telegram_Mock_Status_Label_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiket yazıcıya gönderildi`)
};

const en_landing_telegram_mock_status_label_sent = /** @type {(inputs: Landing_Telegram_Mock_Status_Label_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label sent to printer`)
};

const de_landing_telegram_mock_status_label_sent = /** @type {(inputs: Landing_Telegram_Mock_Status_Label_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etikett an Drucker gesendet`)
};

const ru_landing_telegram_mock_status_label_sent = /** @type {(inputs: Landing_Telegram_Mock_Status_Label_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этикетка отправлена на принтер`)
};

/**
* | output |
* | --- |
* | "Label sent to printer" |
*
* @param {Landing_Telegram_Mock_Status_Label_SentInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_status_label_sent = /** @type {((inputs?: Landing_Telegram_Mock_Status_Label_SentInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_Status_Label_SentInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_status_label_sent(inputs)
	if (locale === "de") return de_landing_telegram_mock_status_label_sent(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_status_label_sent(inputs)
	return tr_landing_telegram_mock_status_label_sent(inputs)
});